module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar1z"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("contents")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION:")]), _vm._v(" FOR THE LOVE OF CATS")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/how#how"
    }
  }, [_vm._v("HOW TO USE THIS BOOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/cat#cat"
    }
  }, [_vm._v("THE CAT LOVER’S YEAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  }), _vm._v(" MONDAY / "), _c('strong', [_vm._v("CATS 101")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  }), _vm._v(" TUESDAY / "), _c('strong', [_vm._v("FELINE FACT AND FICTION")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  }), _vm._v(" WEDNESDAY / "), _c('strong', [_vm._v("HEALTH AND WELLNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  }), _vm._v(" THURSDAY / "), _c('strong', [_vm._v("THE HOUSE CAT—PROJECTS, TIPS, AND MORE")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  }), _vm._v(" FRIDAY / "), _c('strong', [_vm._v("CAT BREEDS")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  }), _vm._v(" SATURDAY + SUNDAY / "), _c('strong', [_vm._v("BONDING AND RELATIONSHIP BUILDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/resources#resources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RESOURCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/credit#credit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PHOTOGRAPHER CREDITS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/about#about",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHORS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 63
// module chunks = 0